import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';
import {LocationSetTypesFacadeService} from '@emm/management/services/location-set-types-facade.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: { '(document:click)': 'onOutsideClick($event)' },
    selector: 'emm-location-sets-dropdown',
    styleUrls: ['./location-sets-dropdown.component.scss'],
    templateUrl: './location-sets-dropdown.component.html',
    standalone: false
})
export class LocationSetsDropdownComponent implements OnInit {

    active = false;
    $event: Event;
    left = 0;
    locationSetTypes$ = this.locationSetTypesFacade.locationSetTypes$;

    constructor(
        private element: ElementRef,
        private locationSetTypesFacade: LocationSetTypesFacadeService,
        private nutritionFacade: NutritionFacadeService) {}

    ngOnInit(): void {
        setTimeout(() => this.active = true, 0);
    }

    handleLocationSetTypeClick({ name, tag }): void {
        this.active = false;
        this.nutritionFacade.selectedNutritionLocationSetType(tag);
    }

    onOutsideClick(event: Event): void {
        if (!this.element.nativeElement.contains(event.target)) {
            this.active = false;
        }
    }



}
